import '../i18n/i18n';
import '../services/socialLogins/google.init';

import React, { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import { Platform, StyleSheet, View } from 'react-native';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { Provider, useDispatch } from 'react-redux';

import { ThemeProvider } from '../config';
import i18n from '../i18n/i18n';
import { useInviteLinkCapture } from '../services/invite/pendingInviteCode';
import { preloadCriticalAssets } from '../services/preloadAssets';
import { store } from '../store';
import { checkAuthRequest } from '../store/auth/authActions';
import { useLanguageInit } from '../utils/helpers/languages';
import { useAuthSessionInvalidation } from '../utils/hooks/useAuthSessionInvalidation';
import { useOnlinePresence } from '../utils/hooks/useOnlinePresence';
import { SafeViewportProvider } from '../utils/hooks/useSafeViewport';
import { useSocialRedirectReturn } from '../utils/hooks/useSocialRedirectReturn';
import InviteLanding from './Components/Friends/InviteFriends/InviteLanding';
import InstallNudgeHost from './Components/Pwa/InstallNudgeHost';
import { BroadcastToastHost } from './navigation/BroadcastToastHost';
import RootNavigator from './navigator';

const Bootstrap = () => {
	const dispatch = useDispatch();

	useLanguageInit();
	useAuthSessionInvalidation();
	useOnlinePresence();
	const { webCode: inviteCode, dismissWebCode } = useInviteLinkCapture();
	// Installed app only: finishes a social login that went out to the provider and back.
	useSocialRedirectReturn();

	useEffect(() => {
		dispatch(checkAuthRequest());
	}, [dispatch]);

	useEffect(() => {
		preloadCriticalAssets();
	}, []);

	useEffect(() => {
		console.log('[V2 Bootstrap] Mounted on platform:', Platform.OS);
	}, []);

	return (
		<>
			<RootNavigator />
			{inviteCode ? <InviteLanding code={inviteCode} onContinue={dismissWebCode} /> : null}
			<InstallNudgeHost />
		</>
	);
};

const App = () => (
	<Provider store={store}>
		<SafeAreaProvider style={styles.safeAreaRoot}>
			<View style={styles.appRoot}>
				<I18nextProvider i18n={i18n}>
					<ThemeProvider>
						<SafeViewportProvider>
							<Bootstrap />
						</SafeViewportProvider>
					</ThemeProvider>
				</I18nextProvider>
				<BroadcastToastHost variant='app' />
			</View>
		</SafeAreaProvider>
	</Provider>
);

export default App;

const styles = StyleSheet.create({
	safeAreaRoot: {
		flex: 1,
		width: '100%',
		minHeight: '100%',
	},
	appRoot: {
		flex: 1,
		width: '100%',
		position: 'relative',
		minHeight: '100%',
	},
	toastHost: {
		...StyleSheet.absoluteFill,
		justifyContent: 'flex-end',
		alignItems: 'center',
		paddingBottom: 20,
		zIndex: 999999,
		elevation: 999999,
		pointerEvents: 'box-none',
	},
});
